import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IReservationData } from 'core-lib';
import { getEventSiteName, getTimeBasedEventName } from '../../phases/find-reservation/find-reservation.utils';

@Component({
    selector: 'app-confirmation-tabledetails',
    imports: [TranslateModule, DatePipe],
    templateUrl: './confirmation-tabledetails.component.html',
    styleUrl: './confirmation-tabledetails.component.scss'
})
export class ConfirmationTabledetailsComponent {
  @Input() reservation: IReservationData;

  get restaurantName(): string {
    return getEventSiteName(this.reservation) ?? this.reservation.roomRate.room.roomName;
  }

  get timeBasedEventName(): string | undefined {
    return getTimeBasedEventName(this.reservation);
  }
}
